
<app-topbar-header></app-topbar-header>
<div class="projects">
    <app-project *ngFor="let project of projects" [project]="project"></app-project>
</div>
